import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "c-image-and-text-section__container" }
const _hoisted_3 = { class: "c-image-and-text-section__media-card" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "c-image-and-text-section__content" }
const _hoisted_6 = {
  key: 2,
  class: "c-image-and-text-section__list"
}

import { computed } from 'vue';
import { RichText, Text as JssText } from '@sitecore-jss/sitecore-jss-vue';
import { ImageAndTextSectionProps } from '@/types/components/ImageAndTextSection';
import utils from '@/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageAndTextSection',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;

const fields = computed(() => props.fields);
const cards = computed(() => fields.value?.cards ?? []);
const hascheck = computed(() => Boolean(fields.value?.hascheck?.value));

const rootClass = computed(() => {
  const result = utils.overall.baseComClass(props.fields, 'c-image-and-text-section');
  if (hascheck.value) {
    result.push('c-image-and-text-section--lnp-formulation');
  }
  return result;
});

const rootStyle = computed(() => {
  return utils.overall.baseComStyle(props.fields);
});

const imageField = computed(() => {
  const image = fields.value?.image as any;
  if (image?.value?.src) return image;
  if (image?.src) return { value: image };
  return image;
});
const imageSrc = computed(() => imageField.value?.value?.src || '');
const imageAlt = computed(() => imageField.value?.value?.alt || '');

return (_ctx: any,_cache: any) => {
  const _component_JssRichText = _resolveComponent("JssRichText")!
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(rootClass.value),
        style: _normalizeStyle(rootStyle.value),
        id: __props.rendering?.dataSource
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [2, 20],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (imageSrc.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "c-image-and-text-section__image",
                      src: imageSrc.value,
                      alt: imageAlt.value,
                      loading: "lazy"
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true),
                (fields.value.imageOverlayText?.value)
                  ? (_openBlock(), _createBlock(_unref(RichText), {
                      key: 1,
                      class: "c-image-and-text-section__image-overlay",
                      field: fields.value.imageOverlayText
                    }, null, 8, ["field"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_JssRichText, {
                  class: "c-image-and-text-section__title",
                  field: fields.value?.title,
                  tag: "h2"
                }, null, 8, ["field"]),
                (cards.value.length)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["c-image-and-text-section__cards", `c-image-and-text-section__cards--count-${cards.value.length}`])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards.value, (card, index) => {
                        return (_openBlock(), _createElementBlock("article", {
                          key: card.id || index,
                          class: _normalizeClass(["c-image-and-text-section__card", `c-image-and-text-section__card--${index + 1}`])
                        }, [
                          (card.fields?.title?.value)
                            ? (_openBlock(), _createBlock(_unref(JssText), {
                                key: 0,
                                class: "c-image-and-text-section__card-title",
                                field: card.fields.title,
                                tag: "h3"
                              }, null, 8, ["field"]))
                            : _createCommentVNode("", true),
                          (card.fields?.description?.value)
                            ? (_openBlock(), _createBlock(_unref(RichText), {
                                key: 1,
                                class: "c-image-and-text-section__card-description",
                                field: card.fields.description
                              }, null, 8, ["field"]))
                            : _createCommentVNode("", true),
                          (card.fields?.items?.length)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.fields.items, (item, itemIndex) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: item.id || itemIndex,
                                    class: "c-image-and-text-section__list-item"
                                  }, [
                                    _cache[0] || (_cache[0] = _createElementVNode("span", {
                                      class: "c-image-and-text-section__check",
                                      "aria-hidden": "true"
                                    }, null, -1)),
                                    (item.fields?.text?.value)
                                      ? (_openBlock(), _createBlock(_unref(JssText), {
                                          key: 0,
                                          class: "c-image-and-text-section__list-text",
                                          field: item.fields.text,
                                          tag: "span"
                                        }, null, 8, ["field"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128))
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        })
      ], 14, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})